module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('confirm-modal', {
    attrs: {
      "id": "confirmRemittanceCreation"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.hasRemittance) ? _c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.mensagem.periodoExistente'))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('remessaIntegracao.mensagem.confirmar'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalCreateRemittance",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmacaoModalCreateRemittance",
      "clickFunction": _vm.create
    }
  })], 1)]), (_vm.show) ? _c('better-modal', {
    attrs: {
      "closable": true,
      "id": "remittanceCreationModal"
    },
    on: {
      "close-modal": function($event) {
        return _vm.$emit("close-modal")
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit("close-modal")
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header",
      "id": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.modal.text.title)
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.modal.text.subtitle)
    }
  })]), _c('div', {
    attrs: {
      "slot": "body",
      "id": "body"
    },
    slot: "body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingData),
      expression: "isLoadingData"
    }],
    staticClass: "col-md-12 col-sm-10"
  }, [_c('div', {
    staticClass: "loadingData"
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoadingData),
      expression: "!isLoadingData"
    }]
  }, [_c('form', {
    staticClass: "form-style",
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "remittanceType"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t("remessaIntegracao.labels.tipoRemessa"))
    }
  }), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('remittance.type')
    },
    attrs: {
      "value": _vm.remittance.type,
      "options": _vm.remittanceTypes,
      "label": "nome",
      "placeholder": _vm.$t("validacao.select.placeholder"),
      "data-vv-name": "remittance.type",
      "name": "remittenceType"
    },
    model: {
      value: (_vm.remittance.type),
      callback: function($$v) {
        _vm.$set(_vm.remittance, "type", $$v)
      },
      expression: "remittance.type"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('remittance.type', 'required')),
      expression: "errors.firstByRule('remittance.type', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 365
    },
    model: {
      value: (_vm.remittance.period),
      callback: function($$v) {
        _vm.$set(_vm.remittance, "period", $$v)
      },
      expression: "remittance.period"
    }
  }), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "remittanceType"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t("remessaIntegracao.labels.comentariosAdicionais"))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remittance.comments),
      expression: "remittance.comments"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "comments",
      "name": "comments",
      "maxlength": "1000",
      "rows": "2",
      "cols": "130"
    },
    domProps: {
      "value": (_vm.remittance.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.remittance, "comments", $event.target.value)
      }
    }
  })])], 1)])]), (!_vm.isLoadingData) ? _c('div', {
    attrs: {
      "slot": "footer",
      "id": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.gerar'),
      "id": "btnGerarArquivo",
      "clickFunction": _vm.validate
    }
  })], 1) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b0335380", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0335380"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/integration/remittanceIntegration/remittanceIntegrationCreationModal.pug
// module id = 1452
// module chunks = 0